import { motion } from "framer-motion";

const NUMBER = "971509764169";
const TEXT = encodeURIComponent("Hello Wexoz, I'd like to discuss a transportation technology requirement.");

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16 3C8.8 3 3 8.8 3 16c0 2.3.6 4.5 1.8 6.5L3 29l6.7-1.8c1.9 1 4.1 1.6 6.3 1.6 7.2 0 13-5.8 13-13S23.2 3 16 3zm0 23.6c-2 0-3.9-.5-5.6-1.5l-.4-.2-4 1.1 1.1-3.9-.3-.4A10.5 10.5 0 0 1 5.4 16C5.4 10.2 10.2 5.4 16 5.4S26.6 10.2 26.6 16 21.8 26.6 16 26.6zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.6-.9-.8-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.6 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export const WhatsAppButton = () => (
  <motion.a
    href={`https://wa.me/${NUMBER}?text=${TEXT}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Wexoz on WhatsApp"
    data-testid="whatsapp-button"
    initial={{ opacity: 0, scale: 0.8, y: 12 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-3 rounded-full bg-[#25D366] pl-3 pr-3 py-3 text-navy shadow-lg shadow-black/40 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-[#25D366]/30 sm:pr-5"
  >
    <WhatsAppIcon className="h-6 w-6" />
    <span className="hidden text-sm font-semibold sm:inline">WhatsApp us</span>
  </motion.a>
);
